import React from 'react';
import { usePatientMetadata } from '../../providers/PatientMetadataProvider';
import { useSubmissionForm } from '../../providers/patient/PatientSubmissionContext';
import { Avatar } from '../Avatar';

const PatientInfo: React.FC = () => {
    const { formData } = useSubmissionForm();
    const { getProfilePictureUrl } = usePatientMetadata();
    const patientName =
        formData?.firstName && formData?.lastName
            ? `${formData.firstName} ${formData.lastName}`
            : 'Patient Name';
    const profilePictureUrl =
        formData?.profilePicture?.preview ||
        (formData?.id ? getProfilePictureUrl(formData.id) : undefined);

    return (
        <div className="flex flex-col gap-6 items-center text-center">
            <h2 className="text-xl font-bold text-gray-800">{patientName}</h2>
            <div className="w-40 md:w-56 max-w-full aspect-square">
                <Avatar
                    user={{ name: patientName, email: '' }}
                    imageFile={formData?.profilePicture?.file}
                    imageURL={profilePictureUrl}
                />
            </div>
        </div>
    );
};

export default PatientInfo;
